<template>
  <div class="main-product-category-slider-container">
    <div
      v-for="(category, index) in productCategories"
      :key="category.id"
      class="product-category"
      :class="{ selected: selectedIndex === index }"
      @click="selectCategory(index)"
    >
      {{ category.name }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedIndex: 0,
    };
  },
  props: {
    productCategories: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  methods: {
    selectCategory(index) {
      this.selectedIndex = index;
      const selectedCategory = this.productCategories[index];
      this.$emit('category-selected', selectedCategory.id);
    },
  },
};
</script>

<style>
.main-product-category-slider-container {
  display: flex;
  position: relative;
  color: rgba(255, 255, 255, 0.8);
  font-size: 16px;
  font-weight: 700;
  font-family: 'Inter', sans-serif;
  overflow: auto;
  align-items: center;
  text-transform: uppercase;
  z-index: 1000;
  background-color: rgba(255, 255, 255, .1);
  padding: 4vw;
  backdrop-filter: blur(50px);
  scrollbar-width: none;
  -ms-overflow-style: none;
  gap: 1vw; /* Добавляем отступ между элементами */
}

.main-product-category-slider-container::-webkit-scrollbar {
  display: none;
}

.product-category {
  padding: 1.5vw 2vw; /* Увеличиваем горизонтальные отступы */
  cursor: pointer;
  white-space: nowrap; /* Запрещаем перенос текста */
  flex-shrink: 0; /* Запрещаем сжатие элементов */
  transition: all 0.3s ease; /* Плавный переход для всех свойств */
  border-radius: 30px; /* Добавляем скругление даже для неактивного состояния */
}

/* Убираем width: max-content, так как flex сам подстроит ширину под контент */

.selected {
  background-color: rgba(255, 255, 255, 0.2);
  /* border-radius уже есть в .product-category */
}
</style>